import React from "react";
import "./BtnMail.scss";

const BtnMail = () => {
  return (
    <a href="mailto:contacto@manuable.com">
      <button className="btn-white">contacto@manuable.com</button>
    </a>
  );
};

export default BtnMail;
